import en from "./en-us"
import cn from "./zh-cn"
import tw from "./zh-tw"
import en_iview from 'view-design/dist/locale/en-US';
import zh_iview from 'view-design/dist/locale/zh-CN';
import tw_iview from 'view-design/dist/locale/zh-TW';

export default {
    en: Object.assign(en_iview,en, ),
    cn: Object.assign(zh_iview,cn, ),
    tw: Object.assign(tw_iview,tw, )
}
 


// WEBPACK FOOTER //
// ./src/i18n/index.js